module.exports = __webpack_public_path__ + "static/media/C_E01.6105a991.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/C_E01.png
// module id = 121
// module chunks = 0